/**
 * Hotel pre-order button text restoration
 *
 * Dawn's product-form.js toggleSubmitButton() hardcodes the enabled-state
 * button text to window.variantStrings.addToCart, which clobbers our
 * server-rendered "Pre-order now" label on every variant change.
 *
 * This script subscribes to Dawn's variantChange event and restores the
 * button text from the freshly-rendered HTML that Dawn already fetched
 * for the variant-change re-render — no need to duplicate the pre-order
 * detection logic in JS.
 *
 * See CLAUDE.md → "Customisation isolation".
 */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const data = event && event.data;
    if (!data || !data.sectionId || !data.html) return;

    const sourceButton = data.html.getElementById('ProductSubmitButton-' + data.sectionId);
    const liveButton = document.getElementById('ProductSubmitButton-' + data.sectionId);
    if (!sourceButton || !liveButton) return;

    const sourceSpan = sourceButton.querySelector('span');
    const liveSpan = liveButton.querySelector('span');
    if (sourceSpan && liveSpan) {
      liveSpan.textContent = sourceSpan.textContent.trim();
    }

    // Sync the --preorder class so CSS colour follows the selected variant
    const hasPreorderClass = sourceButton.classList.contains('product-form__submit--preorder');
    liveButton.classList.toggle('product-form__submit--preorder', hasPreorderClass);

    // Sync the hidden pre-order line item property input. We mirror BOTH value
    // and the disabled flag: when the freshly-rendered variant is not on
    // pre-order the server emits the input as disabled, which excludes it from
    // the FormData add-to-cart payload, so no empty "PRE-ORDER" property is
    // attached to the order. (Shopify does NOT drop empty-valued properties.)
    const sourceInput = data.html.querySelector('[data-hotel-preorder-input]');
    const liveInput = document.querySelector('[data-hotel-preorder-input]');
    if (sourceInput && liveInput) {
      liveInput.value = sourceInput.value;
      liveInput.disabled = sourceInput.disabled;
    }
  });
}
